import { useAuthStore } from "@/features/auth/auth.store";
import type { Router } from "vue-router";

const mockAuthStorageKey = "konek_mock_authenticated";
const userStorageKey = "user";
let isCrossTabLogoutSyncRegistered = false;

const isLogoutStorageEvent = (event: StorageEvent) =>
  (event.key === userStorageKey && event.newValue === null) ||
  (event.key === mockAuthStorageKey && event.newValue !== "true");

export function setupAuthGuard(router: Router) {
  if (typeof window !== "undefined" && !isCrossTabLogoutSyncRegistered) {
    window.addEventListener("storage", (event) => {
      if (!isLogoutStorageEvent(event)) return;

      const auth = useAuthStore();

      auth.clearSession();

      if (router.currentRoute.value.meta.guestOnly) return;

      void router.replace({ name: "login" });
    });

    isCrossTabLogoutSyncRegistered = true;
  }

  router.beforeEach(async (to) => {
    const auth = useAuthStore();

    if (to.meta.requiresAuth) await auth.fetchCurrentUser();

    if (to.meta.requiresAuth && !auth.isAuthenticated) return { name: "login" };

    if (to.meta.guestOnly && auth.isAuthenticated) return { name: "dashboard" };

    return true;
  });
}
